import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPause, faPlay, faRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { STORY_SCENES, STORY_TIMELINE, StoryScene } from './story';
import { S } from './styles';

interface StoryControlsProps {
  scene: StoryScene;
  elapsed: number;
  showingIntro: boolean;
  withIntro: boolean;
  playing: boolean;
  manuallySelected: boolean;
  reducedMotion: boolean;
  onSelectScene: (scene: StoryScene) => void;
  onSelectIntro: () => void;
  onTogglePlayback: () => void;
  onReplay: () => void;
}

export const StoryControls: React.FC<StoryControlsProps> = ({
  scene,
  elapsed,
  showingIntro,
  withIntro,
  playing,
  manuallySelected,
  reducedMotion,
  onSelectScene,
  onSelectIntro,
  onTogglePlayback,
  onReplay
}) => {
  const active = STORY_SCENES[scene];

  return (
    <S.Controls>
      <S.Chapters aria-label="Platform story scenes" count={STORY_SCENES.length + (withIntro ? 1 : 0)}>
        {withIntro && (
          <S.Chapter type="button" aria-current={showingIntro ? 'step' : undefined} onClick={onSelectIntro}>
            <S.Progress data-selected={showingIntro && manuallySelected}>
              <span
                style={{
                  transform: `scaleX(${showingIntro ? Math.min(1, elapsed / STORY_TIMELINE.introScreenMs) : 1})`
                }}
              />
            </S.Progress>
            <S.ChapterLabel>
              <small>00</small>
              <span>Meet the platform</span>
            </S.ChapterLabel>
          </S.Chapter>
        )}
        {STORY_SCENES.map((item) => (
          <S.Chapter
            key={item.id}
            type="button"
            aria-current={!showingIntro && scene === item.id ? 'step' : undefined}
            onClick={() => onSelectScene(item.id)}
          >
            <S.Progress data-selected={!showingIntro && scene === item.id && manuallySelected}>
              <span
                style={{
                  transform: `scaleX(${showingIntro ? 0 : item.id < scene ? 1 : item.id === scene ? Math.min(1, elapsed / active.durationMs) : 0})`
                }}
              />
            </S.Progress>
            <S.ChapterLabel>
              <small>0{item.id + 1}</small>
              <span>{item.label}</span>
            </S.ChapterLabel>
          </S.Chapter>
        ))}
      </S.Chapters>
      <S.Playback>
        {!reducedMotion ? (
          <button
            type="button"
            onClick={onTogglePlayback}
            aria-label={playing ? 'Pause story' : 'Play story'}
            title={playing ? 'Pause' : 'Play'}
          >
            <FontAwesomeIcon icon={playing ? faPause : faPlay} />
          </button>
        ) : null}
        <button type="button" onClick={onReplay} aria-label="Replay story" title="Replay">
          <FontAwesomeIcon icon={faRotateLeft} />
        </button>
      </S.Playback>
    </S.Controls>
  );
};
